module.exports = __webpack_public_path__ + "Simple-Line-Icons.2fe2efe63441d830b1ac.svg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.svg?v=2.4.0
// module chunks = styles